import { Card, CardHeader } from "../ui/card";

interface Props {
    currentStep: number;
}

export default function ProgressIndicator({ currentStep }: Props) {
    const steps = ["Paket", "Konfirmasi", "Pembayaran", "Status Pembayaran", "Kartu Peserta"];

    return (
        <>
            <Card className="border-0 shadow-lg border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 mb-10">
                <CardHeader className="pb-0">

                    {/* WRAPPER SCROLL */}
                    <div className="w-full overflow-x-auto px-2" style={{ WebkitOverflowScrolling: "touch" }}>

                        {/* FLEX AREA */}
                        <div
                            className="
                                inline-flex 
                                space-x-4 
                                min-w-max 
                                whitespace-nowrap 
                                touch-pan-x
                                md:justify-center 
                                w-full
                            "
                        >
                            {steps.map((label, index) => (
                                <div key={index} className="flex items-center space-x-2">
                                    <div
                                        className={`flex h-8 w-8 items-center justify-center rounded-full font-semibold ${index + 1 <= currentStep
                                                ? "bg-blue-600 text-white"
                                                : "bg-gray-200 text-gray-500"
                                            }`}
                                    >
                                        {index + 1}
                                    </div>

                                    <span
                                        className={`text-sm ${index + 1 <= currentStep
                                                ? "text-foreground"
                                                : "text-gray-400"
                                            }`}
                                    >
                                        {label}
                                    </span>

                                    {index < steps.length - 1 && (
                                        <div className="h-px w-8 bg-gray-300"></div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </CardHeader>
            </Card>
        </>
    );
}
